import React from 'react';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import ReferralIcon from '../ReferralIcon';

const CTASection = ({ onOpenReferralModal }) => (
  <div className="hidden 2xl:flex items-center gap-5 flex-shrink-0">
    <a
      href="tel:+18777725150"
      className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap flex-shrink-0"
    >
      <Phone className="w-4 h-4 flex-shrink-0" />
      <span className="font-medium whitespace-nowrap">(877) 772-5150</span>
    </a>

    <Link
      to="/intake"
      className="flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg hover:from-green-700 hover:to-green-800 transition-all font-bold text-sm shadow-md hover:shadow-lg transform hover:scale-105 whitespace-nowrap flex-shrink-0"
      title="Begin the intake process"
      data-testid="nav-get-started-btn"
    >
      <span>GET STARTED</span>
    </Link>

    <ReferralIcon onOpenModal={onOpenReferralModal} />
  </div>
);

export default CTASection;
